<template>
  <section class="py-5 bg-light">
    <div class="container">
      <div class="row text-center gy-3">
        <div class="col-lg-4">
          <div class="d-inline-block">
            <div class="d-flex align-items-end">
              <img
                src="@a/src/assets/img/Orion_delivery-time.svg"
                alt=""
                height="50px"
              />

              <div class="text-start ms-3">
                <h6 class="text-uppercase mb-1">Free shipping</h6>
                <p class="text-sm mb-0 text-muted">Free shipping worldwide</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="d-inline-block">
            <div class="d-flex align-items-end">
              <img
                src="@a/src/assets/img/Orion_helpline-24h.svg"
                alt=""
                height="50px"
              />
              <div class="text-start ms-3">
                <h6 class="text-uppercase mb-1">24 x 7 service</h6>
                <p class="text-sm mb-0 text-muted">Free shipping worldwide</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="d-inline-block">
            <div class="d-flex align-items-end">
              <img
                src="@a/src/assets/img/Orion_label-tag.svg"
                alt=""
                height="50px"
              />
              <div class="text-start ms-3">
                <h6 class="text-uppercase mb-1">Festivaloffers</h6>
                <p class="text-sm mb-0 text-muted">Free shipping worldwide</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Services",
};
</script>

<style>
</style>